import Vue from "vue";
import Vuex from "vuex";
import services from "./services";

Vue.use(Vuex);

const state = {
  services,
  windowSize: 0,
  studio: ["Studio DK", "Studio B", "Soba 24", "Soba 17"],
  appointments: [],
  daysOfTheWeek: [
    {
      Name: "Ponedjeljak",
      Value: 1
    },
    {
      Name: "Utorak",
      Value: 2
    },
    {
      Name: "Srijeda",
      Value: 3
    },
    {
      Name: "Četvrtak",
      Value: 4
    },
    {
      Name: "Petak",
      Value: 5
    },
    {
      Name: "Subota",
      Value: 6
    },
    {
      Name: "Nedjelja",
      Value: 0
    }
  ],
  selectedAppointment: 0,
  detailsDialog: false,

  //Response message
  responseMessage:{}, 
  responseMessageActive:false,
  showNotification: false,
  showUnpaidSubscriptionNotification: false
};

export const store = new Vuex.Store({
  state,
  getters: {
    getStudioDK: state => date => {
      return state.appointments.filter(a => a.Date == date && a.StudioId == 1);
    },
    getStudioB: state => date => {
      return state.appointments.filter(a => a.Date == date && a.StudioId == 2);
    },
    getSoba24: state => date => {
      return state.appointments.filter(a => a.Date == date && a.StudioId == 3);
    },
    getSoba17: state => date => {
      return state.appointments.filter(a => a.Date == date && a.StudioId == 4);
    },
    getByStudioAndDate: state => payload => {
      return state.appointments.filter(a => a.Date == payload.Date && a.StudioId == payload.StudioId);
    },
    getWindowSize: state => {
      return window.innerWidth;
    },
    getDaysOfTheWeek: state => {
      return state.daysOfTheWeek;
    },
    getStudio: state => {
      return state.studio;
    },
    getSelectedAppointment: state => {
      return state.selectedAppointment;
    },
    getDetailsDialog: state => {
      return state.detailsDialog;
    },
    getResponseMessage: state => {
      return state.responseMessage;
    },
    isResponseMessageActive: state => {
      return state.responseMessageActive;
    },
    showNotification: state => {
      return state.showNotification;
    },
    showUnpaidSubscriptionNotification: state => {
      return state.showUnpaidSubscriptionNotification;
    },
  },
  mutations: {
    createNewAppointment: (state, payload) => {
      state.appointments.push(payload);
    },
    setWindowSize: (state, payload) => {
      state.windowSize = payload;
    },
    setAppointments: (state, date) => {
      state.services.appointmentService
        .getByDate(date)
        .then(result => {
          state.appointments = result.data;
        })
        .catch(err => {
          alert(err);
        });
    },
    setSelectedAppointment: (state, payload) => {
      state.selectedAppointment = payload;
    },
    setDetailsDialog: (state,payload) => {
      state.detailsDialog = payload;
    },
    setResponseMessage: (state,payload) => {
      state.responseMessage = payload;
      state.responseMessageActive = true;
      setTimeout(() => {
        state.responseMessageActive = false;
      }, 10000);
    },
    setShowNotification: (state, showNotification) => {
      state.showNotification = showNotification;
    },
    showUnpaidSubscriptionNotification: (state, showNotification) => {
      state.showUnpaidSubscriptionNotification = showNotification;
    },
  },
  actions: {
    setWindowSize: (context, payload) => {
      context.commit("setWindowSize", payload);
    },
    createNewAppointment: (context, payload) => {
      context.commit("createNewAppointment", payload);
    },
    setAppointments: ({ commit }, date) => {
      commit("setAppointments", date);
    },
    setResponseMessage: ({ commit }, payload) => {
      commit("setResponseMessage", payload);
    },
    setShowNotification: ({ commit }, showNotification) => {
      commit("setShowNotification", showNotification);
    },
    setShowUnpaidSubscriptionNotification: ({ commit }, showNotification) => {
      commit("showUnpaidSubscriptionNotification", showNotification);
    },
  }
});
